import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import template from '@/../templates/dialog-upgrade-devices.hbs';

    var UpgradeDevicesDialog = Marionette.View.extend(DialogInterface).extend({
        template: Handlebars.compile(template),
        initialize: function (options) {
            this.destroyOnClose();
            this.focusFirstInput();
        },
        ui: {
            upgrade_option: 'input[name=upgrade-option]',
            submit_button: 'button.btn-primary'
        },
        events: {
            'submit form': 'on_submit',
            'click @ui.upgrade_option': 'set_button_text',
        },
        templateContext: function(){
            return {
                current_deployment: this.model.rel && this.model.rel.get('current_deployment').get('sha') || 'None',
                minimum_deployment: this.model.rel && this.model.rel.get('min_supported_deployment').get('sha') || 'None',
            };
        },
        onRender: function(){
            this.hideAlert();
        },
        set_button_text: function(){
            var upgrade_option = this.ui.upgrade_option.filter(':checked').val();
            switch (upgrade_option) {
                case 'conditional':
                    this.ui.submit_button.text('Conditional Restart');
                    break;
                case 'forced':
                    this.ui.submit_button.text('Forced Restart');
                    break;
                default:
                    this.on_error(null, '');
            }
        },
        on_submit: function (e) {
            e.preventDefault();
            this.hideAlert();
            var upgrade_option = this.ui.upgrade_option.filter(':checked').val();
            switch (upgrade_option) {
                case 'conditional':
                    this.model.conditional_restart().done(this.on_success.bind(this)).fail(this.on_error.bind(this));
                    break;
                case 'forced':
                    this.model.restart().done(this.on_success.bind(this)).fail(this.on_error.bind(this));
                    break;
                default:
                    this.on_error(null, '');
            }
        },
        on_success: function () {
            this.closeDialog();
        },
        on_error: function (devicegroup, resp) {
            var errors = ['An error occurred.'];
            if (resp
                && resp.responseJSON
                && resp.responseJSON.errors
                && resp.responseJSON.errors.length
            ) {
                errors = _.map(resp.responseJSON.errors, function (err) {
                    
                    return err.detail;
                });
            }

            this.showAlert('error', errors.join(' '));
        }
    });
    export default UpgradeDevicesDialog;

